import React, { useEffect, useState } from "react";
import { api, apiJson } from "@/api/client.js";
import { PhotoLightbox } from "@/components/PhotoLightbox.jsx";
import { useOrignalUi } from "@/hooks/useOrignalUi.js";

export function ReconstructionPage() {
  const { ui } = useOrignalUi();
  const t = ui.rebuild;
  const [pack, setPack] = useState(null);
  const [answers, setAnswers] = useState({});
  const [msg, setMsg] = useState("");
  const [index, setIndex] = useState(-1);
  const [gallery, setGallery] = useState([]);

  async function reload() {
    const data = await api("/api/admin/prospection/reconstruction");
    setPack(data);
    const next = {};
    for (const q of data.questions || []) next[q.id] = q.answer || "";
    setAnswers(next);
  }

  useEffect(() => {
    reload().catch(() => setMsg(ui.errors.network));
  }, []);

  async function saveAnswer(qid) {
    await apiJson(`/api/admin/prospection/questions/${qid}/answer`, { answer: answers[qid] || "" });
    setMsg(t.saved);
    await reload();
  }

  async function confirm(id, title) {
    await apiJson(`/api/admin/prospection/moments/${id}/confirm`, { title: title || "", note: answers[id] || "" });
    setMsg(t.saved);
    await reload();
  }

  async function correct(id, title) {
    await apiJson(`/api/admin/prospection/moments/${id}/correct`, { title: title || "", note: answers[id] || "" });
    setMsg(t.saved);
    await reload();
  }

  if (!pack) {
    return <div className="og-rebuild" data-testid="page-rebuild"><p className="og-hint">{ui.app.loading}</p></div>;
  }

  return (
    <div className="og-rebuild" data-testid="page-rebuild">
      <header className="og-panel">
        <p className="og-kicker">DEV</p>
        <h1>{t.title}</h1>
        <p>{t.lead}</p>
        <p>{t.present}: {(pack.present || []).join(", ")}</p>
        {msg ? <p className="og-hint">{msg}</p> : null}
      </header>

      {(pack.questions || []).map((q) => (
        <section key={q.id} className="og-panel og-rebuild__q" data-testid={`rebuild-q-${q.id}`}>
          <p className="og-kicker">{q.id} · {q.date_range}</p>
          <p><strong>{q.question}</strong></p>
          <p className="og-hint">{q.pourquoi}</p>
          {q.message_associe ? <blockquote>{q.message_associe}</blockquote> : null}
          <textarea
            className="og-input"
            rows={3}
            value={answers[q.id] || ""}
            onChange={(e) => setAnswers((s) => ({ ...s, [q.id]: e.target.value }))}
            placeholder={t.answerPh}
            data-testid={`rebuild-answer-${q.id}`}
          />
          <button type="button" className="og-btn og-btn--primary" onClick={() => saveAnswer(q.id)}>{t.saveAnswer}</button>
        </section>
      ))}

      {(pack.moments || []).map((mom) => {
        const photos = (mom.photos || []).filter((p) => p.url && p.file_ok !== false);
        const q = mom.question;
        return (
          <section key={mom.id} className="og-panel og-rebuild__moment" data-testid={`rebuild-moment-${mom.id}`}>
            <p className="og-kicker">{mom.technical_label}</p>
            <h2>{mom.marcel_title || mom.label_neutral}</h2>
            {mom.title_suggested ? <p className="og-hint">{t.suggested}: {mom.title_suggested} — {t.unconfirmed}</p> : null}
            {photos.length ? (
              <div className="og-album og-album--moment">
                {photos.map((p, i) => (
                  <button
                    key={p.id}
                    type="button"
                    className="og-album__shot"
                    style={{ backgroundImage: `url(${p.url})` }}
                    onClick={() => { setGallery(photos); setIndex(i); }}
                  />
                ))}
              </div>
            ) : null}
            {(mom.messages || []).map((m) => (
              <p key={m.id}><strong>{m.author}</strong> — {m.body}</p>
            ))}
            {q ? <p className="og-hint">{q.question}</p> : null}
            <label className="og-hint">{t.answerPh}
              <input
                className="og-input"
                value={answers[mom.id] || mom.marcel_note || ""}
                onChange={(e) => setAnswers((s) => ({ ...s, [mom.id]: e.target.value }))}
              />
            </label>
            <div className="og-home__actions">
              <button type="button" className="og-btn og-btn--primary" onClick={() => confirm(mom.id, mom.title_suggested || mom.label_neutral)} data-testid={`rebuild-confirm-${mom.id}`}>{t.confirm}</button>
              <button type="button" className="og-btn" onClick={() => correct(mom.id, mom.label_neutral)} data-testid={`rebuild-correct-${mom.id}`}>{t.correct}</button>
            </div>
          </section>
        );
      })}
      {index >= 0 ? (
        <PhotoLightbox items={gallery} index={index} onIndex={setIndex} onClose={() => setIndex(-1)} ui={ui} />
      ) : null}
    </div>
  );
}
